<template>
    <input
        ref="input"
        type="checkbox"
        class="
            rounded border-gray-300 text-indigo-600 shadow-sm
            focus:border-indigo-300 focus:ring focus:ring-offset-0 focus:ring-indigo-200 focus:ring-opacity-50
        "
        :value="value" v-model="model">
</template>

<script>

import FormInput from "@/Mixins/FormInput";

export default {

    name: "Checkbox",

    mixins: [FormInput],

    props: {
        value: {}
    },

    methods: {
        mainElement() {
            return this.$refs.input;
        },
    }
};

</script>
